import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { loggedInInfluencerChannelListFailure, loggedInInfluencerChannelListSuccess } from '../../actions/InfluencerCampaignActions/loggedInInfluencerChannelListActions';

function* loggedInInfluencerChannelList({ callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.loggedInInfluencerChannelList,
            isAuth: true,
        });
        console.log('====================================');
        console.log("LOGGED_IN_INFLUENCER_CHANNEL_LIST_SUCCESS status :", response.data.status);
        console.log("LOGGED_IN_INFLUENCER_CHANNEL_LIST_SUCCESS data :", response.data.response);
        console.log("LOGGED_IN_INFLUENCER_CHANNEL_LIST_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            loggedInInfluencerChannelListSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("LOGGED_IN_INFLUENCER_CHANNEL_LIST_FAILURE status :", error?.response?.status);
        console.log("LOGGED_IN_INFLUENCER_CHANNEL_LIST_FAILURE data:", error?.response?.data);
        console.log("LOGGED_IN_INFLUENCER_CHANNEL_LIST_FAILURE error :", error);
        console.log('====================================');
        yield put(loggedInInfluencerChannelListFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* loggedInInfluencerChannelListSaga() {
    yield takeLatest(actionTypes.LOGGED_IN_INFLUENCER_CHANNEL_LIST_REQUEST, loggedInInfluencerChannelList);
}

export default loggedInInfluencerChannelListSaga;
